/*
 * Copyright (c) 2020 Staffino, s.r.o. - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 * Created by Martin Komara, May 2020
 */

import React from 'react';
import { FlowBlockAgreement as BlockModel } from '@staffino/model';
import { LegalBlock as Component } from '@staffino/flow-controls';
import useObjects from '../use-objects-hook';
import LinkCatcher from '../controls/link-catcher';
import useTemplateRenderer from '../use-template-renderer';

type Props = {
  block: BlockModel;
};

const LegalBlock = ({ block }: Props) => {
  const [agreement] = useObjects('legal-agreement', { id: block.agreementId });
  const [content] = useTemplateRenderer(agreement?.content);
  const [title] = useTemplateRenderer(agreement?.documentationTitle);
  const [url] = useTemplateRenderer(agreement?.documentationUrl);
  return (
    <LinkCatcher>
      <Component
        block={block}
        agreement={{
          ...agreement,
          content,
          documentationTitle: title,
          documentationUrl: url,
        }}
      />
    </LinkCatcher>
  );
};

export default LegalBlock;
